import e from"react";const t=({children:t,className:a,style:s})=>e.createElement("div",{className:a,style:s,"data-testid":"card-content"},t);export{t as default};
